/**
 * Mega menu (single menu item)
 */
var component_mega_menu = function(args) {

  // setup args
  var menu = args.menu;
  initMegaMenu();

  function initMegaMenu() {
    setPos();
    // wrapImgItemContent();
    addClasses();
  }

  /**
   * Sets menu top position according to header height
   */
  function setPos() {
    let headerHeight = document.querySelector('.site-header__inner').offsetHeight;
    menu.querySelector('.sub-menu').style.top = headerHeight + 'px';
  }

  /**
   * Adds class .mega-menu-item to all li elements in mega menu
   */
  function addClasses() {
    let liElements = menu.querySelectorAll('li');

    for (var i = 0; i < liElements.length; i++) {
      liElements[i].classList.add('mega-menu-item');
    }
  }

  /**
   * Wraps a menu element's, that has a image, link's text content with a span.
   * Then wraps link elements spans with a div
   */
  // function wrapImgItemContent () {
  //   let linkEl = menu.querySelector('.mega-menu-item-has-img a');

  //   // loop child nodes
  //   for (var i = 0; i < linkEl.childNodes.length; i++) {
  //     // if is a text node
  //     if (linkEl.childNodes[i].nodeName === '#text') {
  //       let textEl = linkEl.childNodes[i];
  //       let parentEl = textEl.parentElement;
  //       // get the text content
  //       let text = textEl.textContent;
  //       // create a new span with that text content
  //       let span = document.createElement('span');
  //       span.textContent = text;
  //       // remove original text node
  //       textEl.remove();
  //       // insert new span before the first child of link element
  //       parentEl.insertBefore(span, parentEl.firstChild);
  //     }
  //   }

  //   // create a new wrap div and insert it in the link element
  //   let div = document.createElement('div');
  //   div.classList.add('mega-menu-text-wrap');
  //   linkEl.insertBefore(div, linkEl.firstChild);

  //   // wrap all spans with div
  //   wrapAll(linkEl.querySelectorAll('span'), div);
  // }



  // make the call chainable
  return this;

};

